export type SessionsSubTab = 'availability' | 'upcoming' | 'past';

type Props = {
    active: SessionsSubTab;
    onChange: (tab: SessionsSubTab) => void;
};

const TABS: { id: SessionsSubTab; label: string }[] = [
    { id: 'availability', label: 'My Availability' },
    { id: 'upcoming', label: 'Upcoming' },
    { id: 'past', label: 'Past Sessions' },
];

const MentorSessionsTabs = ({ active, onChange }: Props) => (
    <div className="d-flex bg-light border border-light-subtle rounded-3 p-1 gap-1 mb-4 w-auto d-inline-flex" role="tablist" id="sessions-tabs">
        {TABS.map((tab) => (
            
                <button
                    key={tab.id}
                    type="button"
                    role="tab"
                    aria-selected={active === tab.id}
                    className={`btn btn-sm border-0 font-12 font-600 py-1 px-3 rounded-2 tab-btn ${active === tab.id ? 'btn-primary' : ''}`}
                    onClick={() => onChange(tab.id)}
                >
                    {tab.label}
                </button>
            
        ))}
    </div>
);

export default MentorSessionsTabs;
